import React from 'react';
import LocationTemplate from './LocationTemplate';

const FourOaksPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Four Oaks"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27524"]}
      latitude={35.4454}
      longitude={-78.4269}
      population={2320}
      historicalFact="Named after four massive oak trees that stood at the original town site."
      nearbyTowns={[
        "Smithfield, NC",
        "Benson, NC",
        "Selma, NC",
        "Clayton, NC",
        "Kenly, NC",
        "Princeton, NC",
        "Pine Level, NC",
        "Micro, NC"
      ]}
    />
  );
};

export default FourOaksPage;